<div id="main-container" class="col-md-4 gradientBg">
  <h1 class="eventsTitle">{{ mainTitle }}</h1>
</div>

@for (text of texts; track text) {
  <div id="questionLists" class="col-md-10 mt-5">
    <article>
      <div class="annualImage">
        <img alt="Annual Statewide Convention Flyer" src="{{ text.img }}" />
      </div>
      <p>{{ text.text1 }}</p>
      <p>{{ text.text2 }}</p>
      <p>{{ text.text3 }}</p>
      <p>{{ text.text4 }}</p>
    </article>
  </div>
}
